import { useState } from 'react';
import { Link } from 'react-router-dom';
import Reveal from '@/components/base/Reveal';
import { homeServices } from '@/mocks/site';

export default function ServicesTabs() {
  const [active, setActive] = useState(0);
  const svc = homeServices[active];

  return (
    <section className="py-16 md:py-[104px] bg-background-100">
      <div className="mx-auto max-w-[1280px] px-5 md:px-8 lg:px-10">
        <Reveal>
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-3 md:gap-4 mb-8 md:mb-12">
            <h2 className="font-heading uppercase text-[30px] md:text-[48px] leading-[0.95]">Core services</h2>
            <Link to="/services" className="text-sm text-foreground-700 hover:text-primary-400 inline-flex items-center gap-2 min-h-[44px] md:min-h-0 whitespace-nowrap cursor-pointer transition-colors">
              View all services <i className="ri-arrow-right-up-line" />
            </Link>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-6">
          <div className="lg:col-span-6 relative aspect-[4/3] md:aspect-auto md:h-[420px] lg:h-auto lg:min-h-[560px] cut-tr cut-tr-lg overflow-hidden bg-background-200">
            <img key={svc.id} src={svc.image} alt={`${svc.title} service`} title={`${svc.title} — Redline Garage`} className="fade-swap absolute inset-0 w-full h-full object-cover object-center" />
            <div className="absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-background-50/80 to-transparent" />
            <span className="absolute left-5 bottom-5 font-heading text-sm tracking-[0.2em] text-foreground-900">0{active + 1} / 0{homeServices.length}</span>
          </div>

          <div className="lg:col-span-6 lg:pl-6 flex flex-col">
            <div role="tablist" aria-label="Services" className="flex flex-col border-t border-background-300/60">
              {homeServices.map((s, i) => {
                const on = i === active;
                return (
                  <button
                    key={s.id}
                    type="button"
                    role="tab"
                    aria-selected={on}
                    onClick={() => setActive(i)}
                    className="group relative w-full text-left cursor-pointer whitespace-nowrap h-14 md:h-[60px] active:bg-background-200/50 md:active:bg-transparent border-b border-background-300/60 flex items-center gap-4 md:gap-5"
                  >
                    <span className={`absolute left-0 bottom-[-1px] h-px bg-primary-500 transition-all duration-300 ${on ? 'w-16' : 'w-0'}`} />
                    <span className={`w-6 text-[11px] font-medium tracking-[0.18em] tabular-nums transition-colors ${on ? 'text-primary-400' : 'text-foreground-600'}`}>0{i + 1}</span>
                    <span className={`flex-1 min-w-0 truncate text-[15px] md:text-[18px] font-heading uppercase tracking-wide transition-colors duration-300 ${on ? 'text-foreground-950' : 'text-foreground-600 group-hover:text-foreground-800'}`}>{s.title}</span>
                    <span className={`w-5 h-5 flex items-center justify-center text-sm transition-all duration-300 ${on ? 'opacity-100 translate-x-0 text-primary-400' : 'opacity-0 -translate-x-1 group-hover:opacity-60 text-foreground-700'}`}><i className="ri-arrow-right-line" /></span>
                  </button>
                );
              })}
            </div>

            <div key={svc.id} role="tabpanel" className="fade-swap mt-7 md:mt-10 lg:mt-auto lg:pt-10">
              <p className="text-[18px] md:text-[19px] leading-snug text-foreground-950 font-medium max-w-[520px]">{svc.summary}</p>
              <p className="mt-3 text-[15px] md:text-sm text-foreground-700 leading-[1.55] md:leading-relaxed max-w-[520px]">{svc.description}</p>
              <p className="mt-5 text-[11px] uppercase tracking-[0.14em] md:tracking-[0.18em] text-foreground-600 leading-[1.7] md:leading-relaxed break-words">
                {svc.points.join(' / ')}
              </p>
              <Link to={`/contact?service=${svc.id}`} className="group mt-5 md:mt-7 inline-flex items-center gap-3 min-h-[44px] text-[13px] font-semibold uppercase tracking-[0.14em] text-foreground-950 whitespace-nowrap cursor-pointer">
                <span className="border-b border-background-400 group-hover:border-primary-500 pb-1 transition-colors">Book {svc.title}</span>
                <span className="w-4 h-4 flex items-center justify-center text-primary-500 transition-transform duration-200 group-hover:translate-x-1 group-hover:-translate-y-1"><i className="ri-arrow-right-up-line" /></span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}